import { Link } from 'react-router-dom';
import { ArrowLeft, Users, Award, Heart, Target } from 'lucide-react';
import { Button } from '@/components/ui/button';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_labresult-hub-1/artifacts/td8pjg41_FACTUAL%20LOGO.png";

const AboutPage = () => {
  return (
    <div className="min-h-screen bg-white dark:bg-slate-900">
      {/* Header */}
      <header className="bg-slate-900 text-white py-4">
        <div className="container mx-auto px-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3">
            <img src={LOGO_URL} alt="Logo" className="w-10 h-10 rounded-full" />
            <span className="font-bold text-lg">Factual Medical Diagnostic Centre</span>
          </Link>
          <Link to="/">
            <Button variant="ghost" className="text-white hover:text-sky-300">
              <ArrowLeft className="w-4 h-4 mr-2" />
              Back to Home
            </Button>
          </Link>
        </div>
      </header>

      {/* Hero */}
      <section className="bg-gradient-to-br from-sky-600 to-sky-800 text-white py-20">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">About Us</h1>
          <p className="text-xl text-sky-100 max-w-2xl mx-auto">
            Your trusted partner in accurate medical diagnostics and healthcare excellence
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="py-16">
        <div className="container mx-auto px-4 max-w-4xl">
          <div className="prose prose-lg dark:prose-invert max-w-none">
            <h2 className="text-3xl font-bold text-slate-900 dark:text-white mb-6">Our Story</h2>
            <p className="text-slate-600 dark:text-slate-400 mb-6">
              Factual Medical Diagnostic Centre was established with a singular vision: to provide accurate, 
              affordable, and accessible medical diagnostic services to communities across Nigeria. Located at 
              No 502, Arogun Bus Stop, Mowe/Ofada Road, Adjacent Medicplus Hospital, Ogun State, we have grown 
              to become a trusted name in healthcare diagnostics.
            </p>
            <p className="text-slate-600 dark:text-slate-400 mb-8">
              Our state-of-the-art laboratory is equipped with modern diagnostic equipment, operated by highly 
              trained medical professionals who are committed to delivering precise results that healthcare 
              providers and patients can trust.
            </p>

            {/* Values */}
            <h2 className="text-3xl font-bold text-slate-900 dark:text-white mb-6">Our Core Values</h2>
            <div className="grid md:grid-cols-2 gap-6 mb-12">
              {[
                { icon: Award, title: 'Accuracy', desc: 'We are committed to delivering precise and reliable diagnostic results.' },
                { icon: Users, title: 'Patient-Centered Care', desc: 'Every patient is treated with respect, dignity, and compassion.' },
                { icon: Target, title: 'Innovation', desc: 'We continuously update our technology and methods to serve you better.' },
                { icon: Heart, title: 'Integrity', desc: 'We uphold the highest ethical standards in all our operations.' }
              ].map((value, i) => (
                <div key={i} className="flex gap-4 p-4 bg-slate-50 dark:bg-slate-800 rounded-lg">
                  <div className="w-12 h-12 bg-sky-100 dark:bg-sky-900 rounded-lg flex items-center justify-center flex-shrink-0">
                    <value.icon className="w-6 h-6 text-sky-600 dark:text-sky-400" />
                  </div>
                  <div>
                    <h3 className="font-bold text-slate-900 dark:text-white">{value.title}</h3>
                    <p className="text-sm text-slate-600 dark:text-slate-400">{value.desc}</p>
                  </div>
                </div>
              ))}
            </div>

            <h2 className="text-3xl font-bold text-slate-900 dark:text-white mb-6">Our Services</h2>
            <ul className="list-disc list-inside text-slate-600 dark:text-slate-400 space-y-2 mb-8">
              <li>Complete Blood Count (CBC) and Hematology Tests</li>
              <li>Lipid Profile and Cardiovascular Screening</li>
              <li>Liver and Kidney Function Tests</li>
              <li>Thyroid Panel and Hormone Tests</li>
              <li>Diabetes Screening (HbA1c, Fasting Glucose)</li>
              <li>Urinalysis and Stool Analysis</li>
              <li>Infectious Disease Testing</li>
              <li>Home Sample Collection Services</li>
            </ul>

            <h2 className="text-3xl font-bold text-slate-900 dark:text-white mb-6">Contact Us</h2>
            <div className="bg-sky-50 dark:bg-sky-900/30 p-6 rounded-lg">
              <p className="text-slate-700 dark:text-slate-300"><strong>Address:</strong> No 502, Arogun Bus Stop, Mowe/Ofada Road, Adjacent Medicplus Hospital, Ogun State, Nigeria</p>
              <p className="text-slate-700 dark:text-slate-300 mt-2"><strong>Phone:</strong> 09049816536, 08025072241, 08141571388</p>
              <p className="text-slate-700 dark:text-slate-300 mt-2"><strong>Email:</strong> FACTUALMEDICALDIAGNOSTICCENTRE@GMAIL.COM</p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-slate-900 text-white py-8">
        <div className="container mx-auto px-4 text-center">
          <p className="text-slate-400">&copy; {new Date().getFullYear()} Factual Medical Diagnostic Centre. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default AboutPage;
